import gql from 'graphql-tag';

import * as Generated from '../../generated/graphql';
import {AccessOptions} from '../../util/permissions';

import {useQuery} from './query';

///// Query definition

export const GROUP_PAGE_QUERY = gql`
  query GroupPage($projectName: String!, $entityName: String) {
    project(name: $projectName, entityName: $entityName) {
      id
      totalRunsWithGroup
      totalRunsWithJobType
      access
      readOnly
      entity {
        id
        defaultAccess
        readOnlyAdmin
        privateOnly
        isTeam
      }
    }
  }
`;

// The query's output shape.
interface GroupPageQueryData {
  project: {
    id: string;
    totalRunsWithGroup: number;
    totalRunsWithJobType: number;
    readOnly: boolean;
    access: AccessOptions;
    entity: {
      id: string;
      defaultAccess: AccessOptions;
      readOnlyAdmin: boolean;
      privateOnly: boolean;
      isTeam: boolean;
    };
  };
}

export function useGroupPageQuery(
  variables: Generated.GroupPageQueryVariables
) {
  return useQuery<GroupPageQueryData, typeof variables>(GROUP_PAGE_QUERY, {
    variables,
  });
}
